/**
 * Contracts for section enablement toggles — RO-2-04 conversion of
 * `excellent/src/sections/enablement-actions.ts`'s
 * `setProjectSectionEnabledAction` + `setWorkspaceSectionEnabledAction`.
 *
 *   POST /api/sections/enablement/project    → toggle one project's section
 *   POST /api/sections/enablement/workspace  → toggle the workspace-tier default
 *
 * Body-only (no `:param`) — no interaction with the `:slug`-keyed sibling
 * routes' registration-order concerns (#44370).
 */
import { z } from "zod";
import type { Operation } from "../types";

export const setProjectEnabledBody = z.object({
  projectId: z.number().int(),
  slug: z.string().min(1),
  enabled: z.boolean(),
});
export type SetProjectEnabledBody = z.infer<typeof setProjectEnabledBody>;

export const setWorkspaceEnabledBody = z.object({
  slug: z.string().min(1),
  enabled: z.boolean(),
});
export type SetWorkspaceEnabledBody = z.infer<typeof setWorkspaceEnabledBody>;

const okResponse = z.object({ ok: z.literal(true) });
export type OkResponse = z.infer<typeof okResponse>;

export const sectionEnablementSetProject: Operation<void, void, SetProjectEnabledBody, OkResponse> = {
  method: "POST",
  path: () => "/api/sections/enablement/project",
  body: setProjectEnabledBody,
  response: okResponse,
};

export const sectionEnablementSetWorkspace: Operation<void, void, SetWorkspaceEnabledBody, OkResponse> = {
  method: "POST",
  path: () => "/api/sections/enablement/workspace",
  body: setWorkspaceEnabledBody,
  response: okResponse,
};

export const sectionEnablement = {
  setProject: sectionEnablementSetProject,
  setWorkspace: sectionEnablementSetWorkspace,
};
